@if (device) {
  <div class="row">
    <div class="col-lg-12">
      <form [formGroup]="deviceSettingsForm" (ngSubmit)="formSubmitSubject.next()">
        <mat-accordion multi="true">
          <!-- Device bitpara settings group-->
          @if (device.bitParaSettings) {
            <mat-expansion-panel>
              <mat-expansion-panel-header>
                <mat-panel-title>
                  <span><span class="fal fa-fw fa-cogs"></span> {{'PARAMETERS' |translate}}</span>
                </mat-panel-title>
              </mat-expansion-panel-header>
              <div formGroupName="devBitParaForm">
                <div class="row">
                  @if (device.bitParaSettings.hasOwnProperty('led') && shouldShowField('led')) {
                    <div class="col-lg-5">
                      <div class="form-group">
                        <label>{{'BITPARA_LED' |translate}}</label>
                        <section>
                          <mat-slide-toggle formControlName="led">
                          </mat-slide-toggle>
                        </section>
                      </div>
                    </div>
                  }
                  <div class="col-lg-5">
                    <div class="form-group">
                      <label>{{'BITPARA_ALARMBEEP' |translate}}</label>
                      <section>
                        <mat-slide-toggle formControlName="alarmBeep">
                        </mat-slide-toggle>
                      </section>
                    </div>
                  </div>
                </div>
                <div class="row">
                  @if (device.bitParaSettings.hasOwnProperty('clock') && shouldShowField('clock')) {
                    <div class="col-lg-5">
                      <div class="form-group">
                        <label>{{'BITPARA_CLOCK' |translate}}</label>
                        <section>
                          <mat-slide-toggle formControlName="clock">
                          </mat-slide-toggle>
                        </section>
                      </div>
                    </div>
                  }
                  @if (device.bitParaSettings.hasOwnProperty('autoAnswer')) {
                    <div class="col-lg-5">
                      <div class="form-group">
                        <label>{{'BITPARA_AUTOANSWER' |translate}}</label>
                        <section>
                          <mat-slide-toggle formControlName="autoAnswer">
                          </mat-slide-toggle>
                        </section>
                      </div>
                    </div>
                  }
                  @if (device.bitParaSettings.hasOwnProperty('qmsgEnabled') && shouldShowField('qmsgEnabled')) {
                    <div class="col-lg-5">
                      <div class="form-group">
                        <label>QMSG</label>
                        <section>
                          <mat-slide-toggle formControlName="qmsgEnabled">
                          </mat-slide-toggle>
                        </section>
                      </div>
                    </div>
                  }
                </div>
                <div class="row" >
                  @if (device.bitParaSettings.hasOwnProperty('presenceMsg') && shouldShowField('presenceMsg')) {
                    <div class="col-lg-5">
                      <div class="form-group">
                        <label>{{'BITPARA_PRESENCEMSG' |translate}}</label>
                        <section>
                          <mat-slide-toggle formControlName="presenceMsg">
                          </mat-slide-toggle>
                        </section>
                      </div>
                    </div>
                  }
                  @if (device.bitParaSettings.hasOwnProperty('ledPulseAlert') && shouldShowField('ledPulseAlert')) {
                    <div class="col-lg-5">
                      <div class="form-group">
                        <label>{{'BITPARA_LEDPULSEALERT' |translate}}</label>
                        <section>
                          <mat-slide-toggle formControlName="ledPulseAlert">
                          </mat-slide-toggle>
                        </section>
                      </div>
                    </div>
                  }
                </div>
                <div class="row">
                  @if (device.bitParaSettings.hasOwnProperty('battLedDisabled') && shouldShowField('battLedDisabled')) {
                    <div class="col-lg-5">
                      <div class="form-group">
                        <label>{{'BITPARA_BATTLED' |translate}}</label>
                        <section>
                          <mat-slide-toggle formControlName="battLedDisabled">
                          </mat-slide-toggle>
                        </section>
                      </div>
                    </div>
                  }
                  @if (device.bitParaSettings.hasOwnProperty('homeCare')) {
                    <div class="col-lg-5">
                      <div class="form-group">
                        <label>{{'BITPARA_HOMECARE' |translate}}</label>
                        <section>
                          <mat-slide-toggle formControlName="homeCare">
                          </mat-slide-toggle>
                        </section>
                      </div>
                    </div>
                  }
                </div>
                <div class="row">
                  @if (device.bitParaSettings.hasOwnProperty('roamingDisabled')) {
                    <div class="col-lg-5">
                      <div class="form-group">
                        <label>{{'BITPARA_ROAMING' |translate}}</label>
                        <section>
                          <mat-slide-toggle formControlName="roamingDisabled">
                          </mat-slide-toggle>
                        </section>
                      </div>
                    </div>
                  }
                  @if (showMiscSettings('voip')) {
                    <div class="col-lg-5">
                      <div class="form-group">
                        <label>{{'VOIP' |translate}}</label>
                        <section>
                          <mat-slide-toggle formControlName="voipEnabled">
                          </mat-slide-toggle>
                        </section>
                      </div>
                    </div>
                  }
                </div>
                <div class="row">
                  @if (device.bitParaSettings.hasOwnProperty('ringerVolume')) {
                    <div class="col-lg-5">
                      <div class="form-group">
                        <label>{{'BITPARA_RINGERVOLUME' |translate}}</label>
                        <section>
                          <mat-form-field>
                            <mat-select formControlName="ringerVolume">
                              <mat-option value="1">{{'RINGER_LOW' |translate}}</mat-option>
                              <mat-option value="0">{{'RINGER_NORMAL' |translate}}</mat-option>
                              <mat-option value="2">{{'RINGER_LOUD' |translate}}</mat-option>
                              <mat-option value="3">{{'RINGER_VERYLOUD' |translate}}</mat-option>
                            </mat-select>
                          </mat-form-field>
                        </section>
                      </div>
                    </div>
                  }
                  @if (device.bitParaSettings.hasOwnProperty('clockBrightness') && shouldShowField('clockBrightness')) {
                    <div class="col-lg-5">
                      <div class="form-group">
                        <label>{{'BITPARA_CLOCK_BRIGHTNESS' |translate}}</label>
                        <section>
                          <mat-form-field>
                            <mat-select formControlName="clockBrightness">
                              <mat-option value="4">{{'BRIGHTNESS_AUTO' |translate}}</mat-option>
                              <mat-option value="0">{{'BRIGHTNESS_VERY_LOW' |translate}}</mat-option>
                              <mat-option value="1">{{'BRIGHTNESS_LOW' |translate}}</mat-option>
                              <mat-option value="2">{{'BRIGHTNESS_NORMAL' |translate}}</mat-option>
                              <mat-option value="3">{{'BRIGHTNESS_HIGH' |translate}}</mat-option>
                            </mat-select>
                          </mat-form-field>
                        </section>
                      </div>
                    </div>
                  }
                </div>
              </div>
              @if (device.deviceType === '31-15') {
                <div formGroupName="sonixxSettingsForm">
                  <div class="form-group">
                    <label>{{'SILENT_MODE' |translate}}</label>
                    <section>
                      <mat-slide-toggle formControlName="silentMode">
                      </mat-slide-toggle>
                    </section>
                  </div>
                  <div class="row">
                    <div class="col-lg-5">
                      <div class="form-group">
                        <label>{{'SPEAKER_VOLUME' |translate}}</label>
                        <section>
                          <mat-form-field>
                            <mat-select formControlName="speakerVolume">
                              <mat-option value="0">{{'AUDIO_LEVEL_LOW' |translate}}</mat-option>
                              <mat-option value="1">{{'AUDIO_LEVEL_MEDIUM' |translate}}</mat-option>
                              <mat-option value="2">{{'AUDIO_LEVEL_HIGH' |translate}}</mat-option>
                            </mat-select>
                          </mat-form-field>
                        </section>
                      </div>
                    </div>
                    <div class="col-lg-5">
                      <div class="form-group">
                        <label>{{'MIC_SENSITIVITY' |translate}}</label>
                        <section>
                          <mat-form-field>
                            <mat-select formControlName="micSensitivity">
                              <mat-option value="0">{{'AUDIO_LEVEL_LOW' |translate}}</mat-option>
                              <mat-option value="1">{{'AUDIO_LEVEL_MEDIUM' |translate}}</mat-option>
                              <mat-option value="2">{{'AUDIO_LEVEL_HIGH' |translate}}</mat-option>
                            </mat-select>
                          </mat-form-field>
                        </section>
                      </div>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-lg-5">
                      <div class="form-group">
                        <label>{{'ALARM_TONE_VOLUME' |translate}}</label>
                        <section>
                          <mat-form-field>
                            <mat-select formControlName="alarmToneVolume">
                              <mat-option value="0">{{'AUDIO_LEVEL_LOW' |translate}}</mat-option>
                              <mat-option value="1">{{'AUDIO_LEVEL_MEDIUM' |translate}}</mat-option>
                              <mat-option value="2">{{'AUDIO_LEVEL_HIGH' |translate}}</mat-option>
                            </mat-select>
                          </mat-form-field>
                        </section>
                      </div>
                    </div>
                    <div class="col-lg-5">
                      <div class="form-group">
                        <label>{{'INDICATION_TONE_VOLUME' |translate}}</label>
                        <section>
                          <mat-form-field>
                            <mat-select formControlName="indicationToneVolume">
                              <mat-option value="0">{{'AUDIO_LEVEL_LOW' |translate}}</mat-option>
                              <mat-option value="1">{{'AUDIO_LEVEL_MEDIUM' |translate}}</mat-option>
                              <mat-option value="2">{{'AUDIO_LEVEL_HIGH' |translate}}</mat-option>
                            </mat-select>
                          </mat-form-field>
                        </section>
                      </div>
                    </div>
                  </div>
                </div>
              }
            </mat-expansion-panel>
          }
          <!--Network settings for TP202-->
          @if (showMiscSettings('network')) {
            <mat-expansion-panel>
              <mat-expansion-panel-header>
                <mat-panel-title>
                  <span><span class="fal fa-fw fa-wifi"></span> {{'NETWORK_SETTINGS' |translate}}</span>
                </mat-panel-title>
              </mat-expansion-panel-header>
              <div formGroupName="devNetworkSettingsForm">
                <div class="form-group mt-3">
                  <h6>{{'TRANSPORT_PRIORITY' |translate}}</h6>
                  <div class="form-inline">
                    <div class="form-group mr-2">
                      <span class="mr-2">1.</span>
                      <mat-form-field>
                        <mat-select formControlName="transportPriority1">
                          <mat-option value="0">GSM</mat-option>
                          <mat-option value="1">Ethernet</mat-option>
                          <mat-option value="2">WiFi</mat-option>
                          @if (transportPriority1.value === '3') {
                            <mat-option value="3">-</mat-option>
                          }
                        </mat-select>
                      </mat-form-field>
                    </div>
                    <div class="form-group mr-2">
                      <span class="mr-2">2.</span>
                      <mat-form-field>
                        <mat-select formControlName="transportPriority2">
                          <mat-option value="0" [disabled]="transportPriority1.value === '0'">GSM</mat-option>
                          <mat-option value="1" [disabled]="transportPriority1.value === '1'">Ethernet</mat-option>
                          <mat-option value="2" [disabled]="transportPriority1.value === '2'">WiFi</mat-option>
                          <mat-option value="3">-</mat-option>
                        </mat-select>
                      </mat-form-field>
                    </div>
                    <div class="form-group mr-2">
                      <span class="mr-2">3.</span>
                      <mat-form-field>
                        <mat-select formControlName="transportPriority3">
                          <mat-option value="0" [disabled]="transportPriority1.value === '0' || transportPriority2.value === '0' || transportPriority2.value === '3'">GSM</mat-option>
                          <mat-option value="1" [disabled]="transportPriority1.value === '1' || transportPriority2.value === '1' || transportPriority2.value === '3'">Ethernet</mat-option>
                          <mat-option value="2" [disabled]="transportPriority1.value === '2' || transportPriority2.value === '2' || transportPriority2.value === '3'">WiFi</mat-option>
                          <mat-option value="3">-</mat-option>
                        </mat-select>
                      </mat-form-field>
                    </div>
                  </div>
                </div>
                @if (showNetworkSettings('0')) {
                  <div>
                    <h6>{{'MODEM_SETTINGS' |translate}}</h6>
                    @if (device.modemSettings.hasOwnProperty('simNetworkMode')) {
                      <div class="form-group">
                        <label>{{'NETWORK_MODE' |translate}} (SIM)</label>
                        <div class="form-group">
                          <mat-form-field>
                            <mat-select formControlName="simNetworkMode" (selectionChange)="simNetworkModeChange($event)">
                              <mat-option value="5">Auto 4G/2G</mat-option>
                              <mat-option value="6">4G</mat-option>
                              <!-- Sonixx cannot make SIP calls over 2G -->
                              @if (!(device.deviceType === '31-15' && simVoiceDomainPreference?.value === '4')) {
                                <mat-option value="1">2G</mat-option>
                              }
                            </mat-select>
                          </mat-form-field>
                        </div>
                      </div>
                    }
                    @if (device.deviceType !== '31-15' && device.modemSettings.hasOwnProperty('eSimNetworkMode')) {
                      <div class="form-group">
                        <label>{{'NETWORK_MODE' |translate}} (eSIM)</label>
                        <div class="form-group">
                          <mat-form-field>
                            <mat-select formControlName="eSimNetworkMode" (selectionChange)="eSimNetworkModeChange($event)">
                              <mat-option value="5">Auto 4G/2G</mat-option>
                              <mat-option value="6">4G</mat-option>
                              <mat-option value="1">2G</mat-option>
                            </mat-select>
                          </mat-form-field>
                        </div>
                      </div>
                    }
                    @if ((device.deviceType === '31-14' || device.deviceType === '31-15') && device.modemSettings.hasOwnProperty('simVoiceDomainPreference')) {
                      <div class="form-group">
                        <label>{{ device.deviceType === '31-15' ? ('SPEECH' | translate) : 'VoLTE (SIM)' }}</label>
                        <div class="form-group">
                          <mat-form-field>
                            <mat-select formControlName="simVoiceDomainPreference" (selectionChange)="simVoiceDomainPreferenceChange($event)">
                              @if (device.deviceType === '31-15' && simNetworkMode?.value === '5') {
                                <mat-option value="2">
                                  VoLTE and 2G call fall back
                                </mat-option>
                              }
                              @if (device.deviceType === '31-15' && simNetworkMode?.value === '6') {
                                <mat-option value="3">
                                  {{'VOLTE_PsVoiceOnly' | translate}}
                                </mat-option>
                              }
                              @if (device.deviceType === '31-15' && simNetworkMode?.value === '1') {
                                <mat-option value="0">
                                  {{'VOLTE_CsVoiceOnly' |translate}}
                                </mat-option>
                              }
                              @if (device.deviceType !== '31-15' && simNetworkMode?.value === '5') {
                                <mat-option value="2">
                                  {{'VOLTE_PsVoicePreferred' | translate}}
                                </mat-option>
                              }
                              @if (device.deviceType !== '31-15' && simNetworkMode?.value === '6') {
                                <mat-option value="3">
                                  {{'VOLTE_PsVoiceOnly' | translate}}
                                </mat-option>
                              }
                              @if (device.deviceType !== '31-15' && simNetworkMode?.value === '5') {
                                <mat-option value="1">
                                  {{'VOLTE_CsVoicePreferred' | translate}}
                                </mat-option>
                              }
                              @if (device.deviceType !== '31-15' && simNetworkMode?.value === '1') {
                                <mat-option value="0">
                                  {{'VOLTE_CsVoiceOnly' | translate}}
                                </mat-option>
                              }
                              <mat-option value="4">
                                {{'VOLTE_VoipPreferred' | translate}}
                              </mat-option>
                            </mat-select>
                          </mat-form-field>
                        </div>
                      </div>
                    }
                    @if (device.deviceType === '31-14' && device.modemSettings.hasOwnProperty('eSimVoiceDomainPreference')) {
                      <div class="form-group">
                        <label>VoLTE (eSIM)</label>
                        <div class="form-group">
                          <mat-form-field>
                            <mat-select formControlName="eSimVoiceDomainPreference">
                              @if (eSimNetworkMode?.value === '5') {
                                <mat-option value="2">
                                  {{'VOLTE_PsVoicePreferred' | translate}}
                                </mat-option>
                              }
                              @if (eSimNetworkMode?.value === '6') {
                                <mat-option value="3">
                                  {{'VOLTE_PsVoiceOnly' | translate}}
                                </mat-option>
                              }
                              @if (eSimNetworkMode?.value === '5') {
                                <mat-option value="1">
                                  {{'VOLTE_CsVoicePreferred' | translate}}
                                </mat-option>
                              }
                              @if (eSimNetworkMode?.value === '1') {
                                <mat-option value="0">
                                  {{'VOLTE_CsVoiceOnly' | translate}}
                                </mat-option>
                              }
                              <mat-option value="4">
                                {{'VOLTE_VoipPreferred' | translate}}
                              </mat-option>
                            </mat-select>
                          </mat-form-field>
                        </div>
                      </div>
                    }
                    @if (device.deviceType !== '31-15' && device.modemSettings.hasOwnProperty('simNetworkMode') && device.modemSettings.hasOwnProperty('eSimNetworkMode')) {
                      <div class="form-group">
                        <label>{{'SIM_MODE' |translate}}</label>
                        <div class="form-group">
                          <mat-form-field>
                            <mat-select formControlName="simMode">
                              <mat-option value="3">{{'SIM_PHYSICAL_FIRST' |translate}}</mat-option>
                              <mat-option value="4">{{'SIM_EMBEDDED_FIRST' |translate}}</mat-option>
                              <mat-option value="1">{{'FORCE_PHYSICAL' |translate}}</mat-option>
                              <mat-option value="2">{{'FORCE_EMBEDDED' |translate}}</mat-option>
                            </mat-select>
                          </mat-form-field>
                        </div>
                      </div>
                    }
                    <div class="form-group">
                      <label>{{'MODEM_ANT_MODE' |translate}}</label>
                      <div class="form-group">
                        <mat-form-field>
                          <mat-select formControlName="modemAntMode">
                            <mat-option value="1">{{'ANTENNA_INTERNAL' |translate}}</mat-option>
                            <mat-option value="2">{{'ANTENNA_EXTERNAL' |translate}}</mat-option>
                          </mat-select>
                        </mat-form-field>
                      </div>
                    </div>
                    <!--Allowed and blocked operator configuration. Displayed only for admins-->
                    @if (user.roleLevel === 200) {
                      <div>
                        @if (device.modemSettings.hasOwnProperty('simNetworkMode')) {
                          <div>
                            <div class="form-group">
                              <label>{{'ALLOWED_OPERATORS' |translate}} (SIM) <span class="fa fa-fw fa-info-circle" matTooltip="{{'OPERATOR_CONFIG_INFO' |translate}}" [matTooltipPosition]="'above'"></span></label>
                              <input type="text" class="form-control" formControlName="simAllowedOperators">
                            </div>
                            <div class="form-group">
                              <label>{{'BLOCKED_OPERATORS' |translate}} (SIM) <span class="fa fa-fw fa-info-circle" matTooltip="{{'OPERATOR_CONFIG_INFO' |translate}}" [matTooltipPosition]="'above'"></span></label>
                              <input type="text" class="form-control" formControlName="simBlockedOperators">
                            </div>
                          </div>
                        }
                        @if (device.modemSettings.hasOwnProperty('eSimNetworkMode')) {
                          <div>
                            <div class="form-group">
                              <label>{{'ALLOWED_OPERATORS' |translate}} (eSIM) <span class="fa fa-fw fa-info-circle" matTooltip="{{'OPERATOR_CONFIG_INFO' |translate}}" [matTooltipPosition]="'above'"></span></label>
                              <input type="text" class="form-control" formControlName="eSimAllowedOperators">
                            </div>
                            <div class="form-group">
                              <label>{{'BLOCKED_OPERATORS' |translate}} (eSIM) <span class="fa fa-fw fa-info-circle" matTooltip="{{'OPERATOR_CONFIG_INFO' |translate}}" [matTooltipPosition]="'above'"></span></label>
                              <input type="text" class="form-control" formControlName="eSimBlockedOperators">
                            </div>
                          </div>
                        }
                      </div>
                    }
                  </div>
                }
                @if (showNetworkSettings('2')) {
                  <div>
                    <h6>{{'WIFI_SETTINGS' |translate}}</h6>
                    <div class="form-group">
                      <label>{{'SSID' |translate}}</label>
                      <input type="text" class="form-control col-lg-3" formControlName="wifiSSID">
                    </div>
                    <div class="form-group">
                      <label>{{'PASSWORD' |translate}}</label>
                      <!-- new-password stops the browser autofilling the user's own Portal login here -->
                      <input type="password" autocomplete="new-password" class="form-control" formControlName="wifiPassword" data-testid="wifi-password">
                    </div>
                    <div class="form-group">
                      <label>DHCP</label>
                      <section>
                        <mat-slide-toggle formControlName="wifiDHCP">
                        </mat-slide-toggle>
                      </section>
                    </div>
                    @if (!deviceSettingsForm.controls.devNetworkSettingsForm.value.wifiDHCP) {
                      <div class="form-row">
                        <div class="form-group col-lg-3">
                          <label>{{'IP_ADDRESS' |translate}}</label>
                          <input type="text" class="form-control" formControlName="wifiIPAddress">
                        </div>
                        <div class="form-group col-lg-3">
                          <label>{{'GATEWAY' |translate}}</label>
                          <input type="text" class="form-control" formControlName="wifiGateway">
                        </div>
                        <div class="form-group col-lg-3">
                          <label>{{'SUBNET_MASK' |translate}}</label>
                          <input type="text" class="form-control" formControlName="wifiSubnetMask">
                        </div>
                      </div>
                    }
                  </div>
                }
                @if (showNetworkSettings('1')) {
                  <div>
                    <h6>{{'ETHERNET_SETTINGS' |translate}}</h6>
                    <div class="form-group">
                      <label>DHCP</label>
                      <section>
                        <mat-slide-toggle formControlName="ethernetDHCP">
                        </mat-slide-toggle>
                      </section>
                    </div>
                    @if (!deviceSettingsForm.controls.devNetworkSettingsForm.value.ethernetDHCP) {
                      <div class="form-row">
                        <div class="form-group col-lg-3">
                          <label>{{'IP_ADDRESS' |translate}}</label>
                          <input type="text" class="form-control" formControlName="ethernetIPAddress">
                        </div>
                        <div class="form-group col-lg-3">
                          <label>{{'GATEWAY' |translate}}</label>
                          <input type="text" class="form-control" formControlName="ethernetGateway">
                        </div>
                        <div class="form-group col-lg-3">
                          <label>{{'SUBNET_MASK' |translate}}</label>
                          <input type="text" class="form-control" formControlName="ethernetSubnetMask">
                        </div>
                      </div>
                    }
                  </div>
                }
                @if (device.deviceType !== '31-15') {
                  <div class="form-group">
                    <h6>{{'WIFI_HOTSPOT_SETTINGS' |translate}}</h6>
                    <label>{{'ENABLED' |translate}}</label>
                    <section>
                      <mat-slide-toggle formControlName="hotspotEnabled">
                      </mat-slide-toggle>
                    </section>
                  </div>
                }
                @if (deviceSettingsForm.controls.devNetworkSettingsForm.value.hotspotEnabled) {
                  <div>
                    <div class="form-group">
                      <label>{{'PASSWORD' |translate}}</label>
                      <input type="text" class="form-control col-lg-3" formControlName="hotspotPassword">
                    </div>
                    <div class="form-group">
                      <label>{{'CHANNEL' |translate}}</label>
                      <mat-form-field class="ml-3">
                        <mat-select formControlName="hotspotChannel">
                          <mat-option value="1">1</mat-option>
                          <mat-option value="2">2</mat-option>
                          <mat-option value="3">3</mat-option>
                          <mat-option value="4">4</mat-option>
                          <mat-option value="5">5</mat-option>
                          <mat-option value="6">6</mat-option>
                          <mat-option value="7">7</mat-option>
                          <mat-option value="8">8</mat-option>
                          <mat-option value="9">9</mat-option>
                          <mat-option value="10">10</mat-option>
                          <mat-option value="11">11</mat-option>
                        </mat-select>
                      </mat-form-field>
                    </div>
                    <div class="form-row">
                      <div class="form-group col-lg-3">
                        <label>{{'IP_ADDRESS' |translate}}</label>
                        <input type="text" class="form-control" formControlName="hotspotIpAddress">
                      </div>
                      <div class="form-group col-lg-3">
                        <label>{{'GATEWAY' |translate}}</label>
                        <input type="text" class="form-control" formControlName="hotspotGateway">
                      </div>
                      <div class="form-group col-lg-3">
                        <label>{{'SUBNET_MASK' |translate}}</label>
                        <input type="text" class="form-control" formControlName="hotspotSubnetMask">
                      </div>
                    </div>
                    <div class="form-group">
                      <label>{{'DHCP_SERVER' |translate}}</label>
                      <section>
                        <mat-slide-toggle formControlName="hotspotDHCPServer">
                        </mat-slide-toggle>
                      </section>
                    </div>
                    @if (deviceSettingsForm.controls.devNetworkSettingsForm.value.hotspotDHCPServer) {
                      <div class="form-row">
                        <div class="form-group col-lg-3">
                          <label>{{'IP_RANGE_START' |translate}}</label>
                          <input type="text" class="form-control" formControlName="hotspotDHCPStart">
                        </div>
                        <div class="form-group col-lg-3">
                          <label>{{'IP_RANGE_END' |translate}}</label>
                          <input type="text" class="form-control" formControlName="hotspotDHCPEnd">
                        </div>
                      </div>
                    }
                  </div>
                }
                @if (device.deviceType !== '31-15') {
                  <div class="form-group">
                    <h6>VPN</h6>
                    <label>{{'ENABLED' |translate}}</label>
                    <section>
                      <mat-slide-toggle formControlName="vpnEnabled">
                      </mat-slide-toggle>
                    </section>
                  </div>
                }
                @if (deviceSettingsForm.controls.devNetworkSettingsForm.value.vpnEnabled) {
                  <div>
                    <div class="form-group">
                      <label>Server 1</label>
                      <input type="text" class="form-control" formControlName="vpnServer1">
                    </div>
                    <div class="form-group">
                      <label>Server 2</label>
                      <input type="text" class="form-control" formControlName="vpnServer2">
                    </div>
                    <div class="form-group">
                      <label>DHCP</label>
                      <section>
                        <mat-slide-toggle formControlName="vpnDhcp">
                        </mat-slide-toggle>
                      </section>
                    </div>
                    @if (!deviceSettingsForm.controls.devNetworkSettingsForm.value.vpnDhcp) {
                      <div class="form-row">
                        <div class="form-group col-lg-3">
                          <label>{{'IP_ADDRESS' |translate}}</label>
                          <input type="text" class="form-control" formControlName="vpnIPAddress">
                        </div>
                        <div class="form-group col-lg-3">
                          <label>{{'GATEWAY' |translate}}</label>
                          <input type="text" class="form-control" formControlName="vpnGateway">
                        </div>
                        <div class="form-group col-lg-3">
                          <label>{{'SUBNET_MASK' |translate}}</label>
                          <input type="text" class="form-control" formControlName="vpnSubnetMask">
                        </div>
                      </div>
                    }
                  </div>
                }
              </div>
            </mat-expansion-panel>
          }
          <!--Bluetooth settings -->
          @if (showMiscSettings('bluetoothSettings')) {
            <mat-expansion-panel>
              <mat-expansion-panel-header>
                <mat-panel-title>
                  <span><span class="fab fa-fw fa-bluetooth-b"></span> Bluetooth</span>
                </mat-panel-title>
              </mat-expansion-panel-header>
              <div formGroupName="bluetoothSettingsFormGroup">
                <div class="form-group">
                  <label>{{'ENABLED' |translate}}</label>
                  <section>
                    <mat-slide-toggle formControlName="bluetoothEnabled">
                    </mat-slide-toggle>
                  </section>
                </div>
              </div>
            </mat-expansion-panel>
          }
          <!--Terminal parameters -->
          @if (showMiscSettings('termParams')) {
            <mat-expansion-panel>
              <mat-expansion-panel-header>
                <mat-panel-title>
                  <span><span class="fal fa-fw fa-cogs"></span> {{'PARAMETERS' |translate}}</span>
                </mat-panel-title>
              </mat-expansion-panel-header>
              <div formGroupName="terminalParameterFormGroup">
                <div class="row">
                  <div class="col-lg-5">
                    <div class="form-group">
                      <label>{{'TERM_PARAM_LOCK_ESCORT' |translate}} (PL-100KG)</label>
                      <section>
                        <mat-slide-toggle formControlName="lockEscort">
                        </mat-slide-toggle>
                      </section>
                    </div>
                  </div>
                  <div class="col-lg-5">
                    @if (user.roleLevel > 100) {
                      <div class="form-group">
                        <label>{{'TERM_PARAM_FALLING_DETECTION' |translate}}</label>
                        <section>
                          <mat-slide-toggle formControlName="fallingDetection" [disabled]="deviceSettingsForm.controls.terminalParameterFormGroup.value.lockEscort">
                          </mat-slide-toggle>
                        </section>
                      </div>
                    }
                  </div>
                </div>
                <div class="row">
                  <div class="col-lg-5">
                    @if (user.roleLevel > 100) {
                      <div class="form-group">
                        <label>{{'TERM_PARAM_MOVEMENT_MONITORING' |translate}}</label>
                        <section>
                          <mat-slide-toggle formControlName="movementMonitoring" [disabled]="deviceSettingsForm.controls.terminalParameterFormGroup.value.lockEscort">
                          </mat-slide-toggle>
                        </section>
                      </div>
                    }
                  </div>
                  <div class="col-lg-5">
                    @if (user.roleLevel > 100) {
                      <div class="form-group">
                        <label>{{'TERM_PARAM_ACCESS_CONTROL' |translate}}</label>
                        <section>
                          <mat-slide-toggle formControlName="accessControl" [disabled]="deviceSettingsForm.controls.terminalParameterFormGroup.value.lockEscort">
                          </mat-slide-toggle>
                        </section>
                      </div>
                    }
                  </div>
                </div>
                <div class="row">
                  <div class="col-lg-5">
                    @if (user.roleLevel > 100) {
                      <div class="form-group">
                        <label>{{'TERM_PARAM_LONG_PRESS' |translate}}</label>
                        <section>
                          <mat-slide-toggle formControlName="longPress">
                          </mat-slide-toggle>
                        </section>
                      </div>
                    }
                  </div>
                </div>
              </div>
            </mat-expansion-panel>
          }
          <!--Misc settings group-->
          @if (showMiscSettings('all')) {
            <mat-expansion-panel>
              <mat-expansion-panel-header>
                <mat-panel-title>
                  <span><span class="fal fa-fw fa-folders"></span> {{'ADDITIONAL_SETTINGS' |translate}}</span>
                </mat-panel-title>
              </mat-expansion-panel-header>
              <div formGroupName="devMiscSettingsForm">
                @if (showMiscSettings('movement')) {
                  <div class="form-group">
                    <label for="movementTimeLimitInput">{{'NON_MOVEMENT_ALARM_TIMELIMIT' |translate}}<br><span [ngClass]="{'text-danger': deviceSettingsForm.controls.devMiscSettingsForm.get('limit').hasError('pattern')}">{{'TIMELIMIT_INFO_NO_DISABLE'
                    |translate}}</span></label>
                    <input type="text" class="form-control mr-2 col-sm-3" formControlName="limit" id="movementTimeLimitInput">
                  </div>
                }
                @if (showMiscSettings('connTimeLim')) {
                  <div class="form-group">
                    <label for="connTimeLimitInput">{{'CONNECTION_TIME_LIMIT' |translate}} <span class="fa fa-fw fa-info-circle" matTooltip="{{'CONNECTION_TIME_LIMIT_HELP' |translate}}"></span><br><span [ngClass]="{'text-danger': deviceSettingsForm.controls.devMiscSettingsForm.get('connTimeLimit').hasError('pattern')}">{{'TIMELIMIT_INFO'
                  |translate}}</span></label>
                  <input type="text" class="form-control mr-2 col-sm-3" formControlName="connTimeLimit" id="connTimeLimitInput">
                </div>
              }
              @if (showMiscSettings('activityMonitoring')) {
                <div class="form-group">
                  <label>{{'NAV_ACTIVITY' |translate}}</label>
                  <section>
                    <mat-slide-toggle formControlName="activityMonitoring">
                    </mat-slide-toggle>
                  </section>
                </div>
              }
            </div>
            <!--Additional settings for TP202-->
            @if (showMiscSettings('tp202_additional')) {
              <div formGroupName="tp202AdditionalForm">
                <hr>
                  @if (user.roleLevel === 200) {
                    <div class="form-group">
                      <label>{{'DTMF_CODE' |translate}}</label>
                      <input type="text" class="form-control col-lg-3" formControlName="dtmfCode">
                    </div>
                  }
                  <hr>
                    @if (user.roleLevel >= 100 && showMiscSettings('tp202_ac_power_alert_delay')) {
                      <div class="form-group">
                        <label>{{'AC_POWER_ALERT_DELAY' |translate}}</label>
                        <input type="text" class="form-control col-lg-3" formControlName="delayACPowerAlert">
                      </div>
                    }
                    <hr>
                      @if (user.roleLevel > 100) {
                        <div class="form-group">
                          <label>{{'MAX_CALL_DURATION' |translate}}</label>
                          <input type="text" class="form-control col-lg-3" formControlName="maxCallDuration">
                        </div>
                      }
                      <hr>
                        @if (user.roleLevel > 100) {
                          <div class="form-group">
                            <label>{{'MAX_CALL_DURATION_EXTENDED' |translate}}</label>
                            <input type="text" class="form-control col-lg-3" formControlName="maxCallDurationExtended">
                          </div>
                        }
                        <hr>
                          @if (user.roleLevel === 200) {
                            <div class="form-group">
                              <label>{{'IGNORE_AUTO_ANSWER_NUMBERS' |translate}}</label>
                              <ul class="ignoreAutoAnswerList">
                                @for (number of deviceSettingsForm.controls.tp202AdditionalForm.value.ignoreAutoAnswer; track number; let i = $index) {
                                  <li>
                                    <span class="mr-3 fal fa-fw fa-trash-alt cursorPointer" (click)="deviceSettingsForm.controls.tp202AdditionalForm.value.ignoreAutoAnswer.splice(i, 1);this.deviceSettingsForm.controls.tp202AdditionalForm.markAsDirty();"></span> {{number}}
                                  </li>
                                }
                              </ul>
                              <div class="form-inline">
                                <div class="form-group">
                                  <input type="text" class="form-control" placeholder="{{'ADD_NEW' |translate}}" #newAutoIgnoreNumber name="newAutoIgnoreNumber">
                                </div>
                                <div class="form-group ml-2">
                                  <button type="button" class="btn btn-primary" (click)="deviceSettingsForm.controls.tp202AdditionalForm.value.ignoreAutoAnswer.push(newAutoIgnoreNumber.value); newAutoIgnoreNumber.value = '';this.deviceSettingsForm.controls.tp202AdditionalForm.markAsDirty();"><span class="fal fa-fw fa-plus"></span></button>
                                </div>
                              </div>
                            </div>
                          }
                          <hr>
                            @if (device.hasOwnProperty('iamOk') && user.roleLevel >= 100) {
                              <div class="form-group">
                                <label>{{'IAM_OK_ENABLED' |translate}}</label>
                                <section>
                                  <mat-slide-toggle formControlName="iAmOkEnabled">
                                  </mat-slide-toggle>
                                </section>
                              </div>
                            }
                            @if (deviceSettingsForm.controls.tp202AdditionalForm.value.iAmOkEnabled) {
                              <div class="form-row">
                                <div class="col">
                                  <label>{{'REPORT_START_TIME' |translate}}</label>
                                  <input class="form-control form-control-sm" [matTimepicker]="iAmOkStartTime" formControlName="iAmOkStartTime">
                                  <mat-timepicker #iAmOkStartTime interval="15m"></mat-timepicker>
                                </div>
                                <div class="col">
                                  <label>{{'REPORT_END_TIME' |translate}}</label>
                                  <input class="form-control form-control-sm" [matTimepicker]="iAmOkEndTime" formControlName="iAmOkEndTime">
                                  <mat-timepicker #iAmOkEndTime interval="15m"></mat-timepicker>
                                </div>
                              </div>
                            }
                          </div>
                        }
                      </mat-expansion-panel>
                    }
                  </mat-accordion>
                  @if (showDeviceSettingsForm()) {
                    <div class="mt-3">
                      @if (saveSuccess) {
                        <div class="alert alert-success">
                          {{'DEVICE_INFORMATION_UPDATED' |translate}}
                        </div>
                      }
                      @if (saveError) {
                        <div class="alert alert-danger" data-testid="save-error">
                          {{'ERROR' |translate}}
                          @if (saveErrorMessage) {
                            <div class="mt-1">{{ saveErrorMessage }}</div>
                          }
                        </div>
                      }
                    </div>
                    <button [disabled]="deviceSettingsForm.pristine || deviceSettingsForm.controls.devMiscSettingsForm.invalid" type="submit" data-testid="submit-btn" class="btn btn-outline-primary gray-bg">
                      {{'SAVE' |translate}}
                    </button>
                  }
                </form>
                @if (showLockBeaconSettings()) {
                  <div>
                    <lock-beacon-settings [device]="device"></lock-beacon-settings>
                  </div>
                }
              </div>
            </div>
          }